module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-form"
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "flex-grow h-full outline-none"
  }, [_c('TextEditor', {
    attrs: {
      "savedContent": _vm.currentSubmission.prompt_response !== null ? _vm.currentSubmission.prompt_response : _vm.currentSubmission.draft_response
    },
    on: {
      "change": _vm.handleResponseChange,
      "editor": function($event) {
        _vm.editor = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "h-16 px-3.5 flex items-center justify-between bg-white border-t border-solid border-gray-200"
  }, [_c('div', [(_vm.getCurrentRT.is_genie_feedback_enable === true && _vm.hasContent) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5"
  }, [_c('Tooltip', {
    staticClass: "flex items-center",
    attrs: {
      "slot": "reference",
      "text": "Genie Feedback",
      "positionTooltip": "relative",
      "backgroundColor": "bg-gray-700"
    },
    slot: "reference"
  }, [_c('button', {
    staticClass: "w-7 h-7 rounded-full bg-gray-700 relative",
    on: {
      "click": function($event) {
        return _vm.handleGenieFeedback()
      }
    }
  }, [(_vm.show_feedback === true) ? _c('div', {
    staticClass: "text-white text-base"
  }, [_c('i', {
    staticClass: "fa-solid fa-xmark"
  })]) : _c('div', {
    staticClass: "w-full h-full relative"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": "/static/roundtable_options_create/genie_icon.svg"
    }
  })])])])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.currentSubmission.start_date) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "sample px-4 py-2 flex justify-between bg-primary hover:bg-primary-dark rounded-lg cursor-pointer text-white disabled:opacity-50",
    attrs: {
      "disabled": _vm.prompt_response === '' || (_vm.prompt_response === _vm.currentSubmission.prompt_response && _vm.isUpdating === false)
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isUpdating === true ? 'Updating' : 'Update') + "\n            "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdating),
      expression: "isUpdating"
    }],
    staticClass: "loader"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.currentSubmission.start_date) ? _c('div', {
    staticClass: "flex space-x-2 items-center"
  }, [_c('button', {
    staticClass: "sample px-5 py-1.5 border rounded cursor-pointer bg-gray-200 text-gray-500 disabled:opacity-50",
    attrs: {
      "disabled": _vm.is_saving || !_vm.recent_changes || _vm.isSavingResponse || _vm.isSavingResponse_autoSave
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveSubmissionContent({
          updateRT: true
        })
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isSavingResponse === true || _vm.isSavingResponse_autoSave === true ? 'Saving...' : !_vm.recent_changes ? 'Saved' : 'Save') + "\n            "), (_vm.isSavingResponse === true || _vm.isSavingResponse_autoSave === true) ? _c('i', {
    staticClass: "fa-solid fa-cloud-arrow-up"
  }) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "sample flex px-5 py-1.5 bg-green rounded cursor-pointer text-white disabled:opacity-50",
    attrs: {
      "disabled": _vm.isEmpty || _vm.is_generating_feedback === true || _vm.is_regenerating === true
    },
    on: {
      "click": function($event) {
        _vm.show_confirm_submit_modal = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isSubmitting === false ? 'Submit' : 'Submitting') + "\n            "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSubmitting),
      expression: "isSubmitting"
    }],
    staticClass: "loader"
  })])]) : _vm._e()])])]), _vm._v(" "), (_vm.show_confirm_submit_modal) ? _c('pl-dialog', {
    attrs: {
      "title": "Submit Response",
      "size": "confirm_size",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.show_confirm_submit_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "h-full w-full overflow-y-auto py-4"
  }, [_c('div', {
    staticClass: "flex flex-col h-full"
  }, [_c('div', {
    staticClass: "overflow-y-auto h-full px-5 mb-4"
  }, [_c('div', [_vm._v("\n            Want to submit your\n            "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("response?")]), _vm._v(" You can\n            "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("edit")]), _vm._v(" any time!\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col px-5 flex-grow h-full"
  }, [_c('div', {
    staticClass: "flex items-end space-x-2 h-full"
  }, [_c('button', {
    staticClass: "bg-gray-100 py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200",
    on: {
      "click": function($event) {
        _vm.show_confirm_submit_modal = false
      }
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-green py-2 flex items-center justify-center space-x-2 text-white font-semibold w-full rounded-md border border-solid border-green",
    on: {
      "click": function($event) {
        return _vm.saveAndPublish()
      }
    }
  }, [_c('span', [_vm._v("Yes, Submit")]), _vm._v(" "), (_vm.isSubmitting === true) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bfbaacea!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/submissionForm/submissionForm.vue
// module id = 1287
// module chunks = 61